import { toast } from 'react-toastify';

export const shortenString = (input, startLength = 8, endLength = 9) => {
  if (input.length <= startLength + endLength) {
    return input; // No need to shorten
  }
  return `${input.slice(0, startLength)}...${input.slice(-endLength)}`;
};

export const handleCopy = (val, message) => {
  navigator.clipboard.writeText(val);
  toast.success(message);
};
